<template>
    <div class="header-spacer">
        <div class="header">
            <nav>
                <div class="logo">
                    <span class="vert-spacer"></span>
                    <a class="vertically-spaced" :href="links[0].url" :title="links[0].title" :aria-label="links[0].name">
                        <img class="standard_logo" :width="logo.width" :height="logo.height" :alt="logo.alt" :src="logo.src" />
                        <img class="mobile_logo" :width="mobileLogo.width" :height="mobileLogo.height" :alt="mobileLogo.alt" :src="mobileLogo.src" />
                    </a>
                </div>
                <div class="items">
                    <a v-for="link in links" :key="link.url" :href="link.url" :title="link.title" :aria-label="link.name">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced">{{ link.name }}</span>
                    </a>
                </div>
                <div class="menu">
                    <a href="#" @click.prevent="toggleMenu" v-click-outside="closeMenu" title="Menu" aria-label="Open menu">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'bars']" aria-label="Open menu"></fa-icon></span>
                    </a>
                </div>
                <div class="profile">
                    <a v-if="isAuthenticated" href="/settings" title="Account Settings" aria-label="Account Settings">
                        <div class="image">
                            <span class="vert-spacer"></span>
                            <span v-if="profileImage !== null" class="vertically-spaced">
                                <img class="vertically-spaced" :src="profileImage" alt="Profile" height="40" />
                            </span>
                            <span v-else class="vertically-spaced">
                                <fa-icon class="nav-icon" :icon="['fas', 'user-circle']" aria-hidden="true"></fa-icon>
                            </span>
                        </div>
                        <div class="name">
                            <span class="vert-spacer"></span>
                            <span class="vertically-spaced name_text">{{ firstName }}<br />{{ lastName }}</span>
                        </div>
                    </a>

                    <a v-if="!isAuthenticated" class="item_link" href="/account/register" title="Register a New Account" aria-label="Register">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced">Register</span>
                    </a>
                    <a v-if="!isAuthenticated" class="item_link" href="/account/log-on" title="Log into your existing account" aria-label="Sign In">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced">Sign In</span>
                    </a>
                </div>
                <div v-if="isAdmin" class="admin">
                    <div class="search-text">
                        <div class="search-input" :selected="searchSelected">
                            <span class="vert-spacer"></span>
                            <span class="vertically-spaced"><input class="search-input" type="text" ref="search-input" v-click-outside="none" placeholder="Admin Search" v-model="searchText" v-on:keyup.enter="searchInputKeyUp" @focus="focusSearchInput" @blur="blurSearchInput" /></span>
                            <a class="vertically-spaced" href="#" @click.prevent="toggleControlPanel" v-click-outside="closeControlPanel">
                                <span class="vert-spacer"></span>
                                <span class="vertically-spaced">
                                    <fa-icon v-show="!showControlPanel" class="nav-icon" :icon="['fas', 'search']" aria-hidden="true"></fa-icon>
                                    <fa-icon v-show="showControlPanel" class="nav-icon" :icon="['fas', 'times-circle']" aria-hidden="true"></fa-icon>
                                </span>
                            </a>
                        </div>
                    </div>

                    <a class="search-link" href="#" @click.prevent="toggleControlPanel" v-click-outside="closeControlPanel" title="Control Panel" aria-label="Control Panel">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'search']" aria-hidden="true"></fa-icon></span>
                    </a>

                    <a class="task-manager" href="/task-manager" title="Task Manager" aria-label="Task Manager">
                        <span class="vert-spacer"></span>
                        <span class="vertically-spaced"><fa-icon class="nav-icon" :icon="['fas', 'tasks']" aria-hidden="true"></fa-icon></span><div v-if="taskCount > 0" class="badge">{{ taskCount }}</div>
                    </a>
                </div>
            </nav>
            <transition name="layoutdropdown">
                <div class="menu-list" v-show="showMenu">
                    <a v-for="link in links" class="item" :key="link.url" v-bind:href="link.url" v-bind:title="link.title" v-bind:aria-label="link.name">
                        <div class="name">{{ link.name }}</div>
                        <div class="title">{{ link.title }}</div>
                    </a>

                    <a v-if="isAdmin" v-click-outside="closeControlPanel" @click.prevent="toggleControlPanel" class="item" href="#" title="Find accounts, log in as users, and access tools to help support customers" aria-label="Control Panel">
                        <div class="name">Control Panel</div>
                        <div class="title">Find accounts, log in as users, and access tools to help support customers</div>
                    </a>
                    <a v-if="isAdmin" class="item" href="/task-manager" title="Manage your tasks" aria-label="Task Manager">
                        <div class="name">Task Manager</div>
                        <div class="title">Manage your tasks</div>
                    </a>

                    <a v-if="isAuthenticated" class="item" href="/settings" :title="firstName + ' ' + lastName + ' account information'" aria-label="Account Information">
                        <div class="name">My Account</div>
                        <div class="title">{{ firstName }} {{ lastName }} account information</div>
                    </a>
                    <a v-if="isAuthenticated && hasRealUsername" class="item" href="/account/log-revert" title="Revert to your original accoumt" aria-label="Revert">
                        <div class="name">Revert</div>
                        <div class="title">Revert to your original account</div>
                    </a>
                    <a v-if="isAuthenticated" class="item" href="/account/log-off" title="Log off your account" aria-label="Sign Out">
                        <div class="name">Sign Out</div>
                        <div class="title">Log off your account</div>
                    </a>

                    <a v-if="!isAuthenticated" class="item" href="/account/register" title="Register a New Account" aria-label="Register">
                        <div class="name">Register</div>
                        <div class="title">Register a New Account</div>
                    </a>
                    <a v-if="!isAuthenticated" class="item" href="/account/log-on" title="Log into your existing account" aria-label="Sign In">
                        <div class="name">Sign In</div>
                        <div class="title">Log into your existing account</div>
                    </a>

                    <div class="item clearfix">
                        <a class="icon-button" href="#" @click.prevent="toggleContext" v-click-outside="closeContext" title="View context information" aria-label="View context information">
                            <fa-icon class="nav-icon" :icon="['fas', 'id-card']" aria-hidden="true"></fa-icon>
                        </a>
                    </div>
                </div>
            </transition>
            <transition name="layoutdropdown">
                <div v-show="showContext" v-click-outside="none" class="content-panel">
                    <context-info @close="closeContext"></context-info>
                </div>
            </transition>
            <transition name="layoutdropdown">
                <div v-if="isAdmin" v-show="showControlPanel" v-click-outside="none" class="content-panel">
                    <control-panel @close="closeControlPanel" ref="controlPanelRef" @update="(text) => searchText = text" :search-text="searchText"></control-panel>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>import script from './primaryHeader';
    export default script;</script>

<style lang="less" scoped>
    @import "./primaryHeader.less";
</style>
